var webcalcDomains = {
    // Germany
    de: { de: ['AUDI.NEW.SKA'] },
    // Belgium
    be: { fr: ['AUDI.BE', 'fr-BE'], nl: ['AUDI.BE', 'nl-BE'] },
    // Switzerland
    ch: {
        de: ['AUDI.CC.CH', 'de-CH'],
        fr: ['AUDI.CC.CH', 'fr-CH'],
        it: ['AUDI.CC.CH', 'it-CH'],
    },
    // Spain
    es: { es: ['AUDI.ES'] },
    // Italy
    it: { it: ['AUDI.CC.IT'] },
    // Norway
    no: { no: ['AUDI.NO'] },
    // Netherlands
    nl: { nl: ['AUDI.NL'] },
    // Sweden
    se: { sv: ['AUDI.SE'] },
    // Ireland
    ie: { en: ['AUDI.IE'] },
    // Poland
    pl: { pl: ['AUDI.PL'] },
    // Japan
    jp: { ja: ['AUDI.JP'] },
    // Portugal
    pt: { pt: ['AUDI.PT'] },
    // SouthAfrica
    za: { en: ['AUDI.ZA'] },
    // France
    fr: { fr: ['AUDI.FR'] },
    // UK ??
    uk: { en: ['AUDI.UK.CRS'] },
    gb: { en: ['AUDI.UK.CRS'] },
};
var defaultFinancingInput = {
    // Germany
    de: {
        de: {
            product: 'VC',
            productParameters: [
                {
                    key: 'Duration',
                    value: '24',
                },
            ],
        },
    },
    // Norway
    no: {
        no: {
            product: 'PLO',
            productParameters: [],
        },
    },
};
export var getDomain = function (_a) {
    var _b;
    var country = _a.country, language = _a.language;
    var domain = (_b = webcalcDomains[country.toLowerCase()]) === null || _b === void 0 ? void 0 : _b[language.toLowerCase()];
    if (!domain) {
        console.debug("Couldn't return Domain for country: ".concat(country, " and language: ").concat(language, " instead returns ").concat(domain, " "));
    }
    return domain;
};
export var getDefaultFinancingInput = function (_a) {
    var _b;
    var country = _a.country, language = _a.language;
    var input = (_b = defaultFinancingInput[country.toLowerCase()]) === null || _b === void 0 ? void 0 : _b[language.toLowerCase()];
    if (!input) {
        console.debug("Couldn't return an input for country: ".concat(country, " and language: ").concat(language, " instead returns ").concat(input, " "));
        return null;
    }
    return input;
};
//# sourceMappingURL=webcalc-domains.js.map